<template>
    <div class="container mx-auto p-8">
        <p class="text-sm font-bold uppercase text-primary">{{ $t('All you will need') }}</p>
        <h2 class="mt-4 text-6xl font-semibold text-camaq-700">{{ $t('The only platform you will need') }}</h2>

        <div class="mt-24 grid gap-5 lg:grid-cols-3">
            <div class="border border-primary bg-[#F9FAFB] p-6">
                <p class="flex items-center space-x-4">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-calendar-bolt"
                        width="30"
                        height="30"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M13.5 21h-7.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5"></path>
                        <path d="M16 3v4"></path>
                        <path d="M8 3v4"></path>
                        <path d="M4 11h16"></path>
                        <path d="M19 16l-2 3h4l-2 3"></path>
                    </svg>
                    <span class="text-sm font-bold uppercase text-camaq-700">{{ $t('Events') }}</span>
                </p>
                <div class="mt-40">
                    <h3 class="text-4xl font-bold text-camaq-700">
                        <InertiaLink href="/evenements">{{ $t('Industry Event') }}</InertiaLink>
                    </h3>
                    <p class="mt-5 text-justify">
                        {{
                            $t(
                                'Every month, the industry offers numerous activities, including webinars, information sessions, live chats, or networking evenings; they are designed for you!'
                            )
                        }}
                    </p>
                </div>
            </div>

            <div class="border border-primary bg-[#FFFAEB] p-6 lg:-mt-10">
                <p class="flex items-center space-x-4">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-school"
                        width="30"
                        height="30"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M22 9l-10 -4l-10 4l10 4l10 -4v6"></path>
                        <path d="M6 10.6v5.4a6 3 0 0 0 12 0v-5.4"></path>
                    </svg>
                    <span class="text-sm font-bold uppercase text-camaq-700">{{ $t('Formations') }}</span>
                </p>
                <div class="mt-40">
                    <h3 class="text-4xl font-bold text-camaq-700">
                        <InertiaLink href="/formations">{{ $t('Aerospace Training Programs') }}</InertiaLink>
                    </h3>
                    <p class="mt-5 text-justify">
                        {{
                            $t(
                                'Explore internship opportunities and the training programs offered by the aviation and aerospace sectors in Canada.'
                            )
                        }}
                    </p>
                </div>
            </div>

            <div class="border border-primary bg-[#F0FDF4] p-6">
                <p class="flex items-center space-x-4">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-file-description"
                        width="30"
                        height="30"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
                        <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"></path>
                        <path d="M9 17h6"></path>
                        <path d="M9 13h6"></path>
                    </svg>
                    <span class="text-sm font-bold uppercase text-camaq-700">{{ $t('Careers') }}</span>
                </p>
                <div class="mt-40">
                    <h3 class="text-4xl font-bold text-camaq-700">
                        <InertiaLink href="/emplois">{{ $t('Aerospace Careers') }}</InertiaLink>
                    </h3>
                    <p class="mt-5 text-justify">
                        {{
                            $t(
                                'Thousands of exciting and stimulating jobs await you in aerospace. Explore these opportunities on Aeroemploi.ca and get ready to take off into an exceptional career.'
                            )
                        }}
                    </p>
                </div>
            </div>
        </div>

        <div class="mt-40 text-center">
            <p class="text-sm font-bold uppercase tracking-widest text-primary">{{ $t('Statistics') }}</p>
            <h2 class="mt-4 text-5xl font-semibold text-camaq-700">{{ $t('An industry in constant evolution') }}</h2>
        </div>

        <div class="mt-16 grid gap-8 md:grid-cols-3">
            <div class="text-center p-8 rounded-xl bg-gray-50">
                <p class="text-6xl font-bold text-primary">96%</p>
                <p class="mt-2 text-lg font-semibold text-camaq-700">{{ $t('Placement rate') }}</p>
            </div>

            <div class="text-center p-8 rounded-xl bg-gray-50">
                <p class="text-6xl font-bold text-primary">{{ props.stats.offers }}+</p>
                <p class="mt-2 text-lg font-semibold text-camaq-700">{{ $t('Active jobs in Quebec') }}</p>
            </div>

            <div class="text-center p-8 rounded-xl bg-gray-50">
                <p class="text-6xl font-bold text-primary">{{ props.stats.companies }}</p>
                <p class="mt-2 text-lg font-semibold text-camaq-700">{{ $t('Quebec companies') }}</p>
            </div>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        stats: Object,
    });
</script>
